import React from 'react';

import { Row, Col, Radio } from 'antd';
import './BeneficiaryDetailsPanel.css';
import FieldValueVerticalCell from 'components/general/FieldValueVerticalCell';
import { getCountryNameByCode } from 'utils/utils'

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import Divider from "antd/es/divider";

const RadioGroup = Radio.Group;

class BeneficiaryDetailsPanel extends React.Component {

  onAccountSelected = val => {
    this.props.onSelectBeneVa(val, this.props.beneficiary.id);
  }

  render() {
    const intl = this.props.useIntl;
    return (
      <>
      <div className="beneficiary-details">

        <Row style={{marginBottom: 16}}>
          <Col md={6} sm={12}>
            <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.beneficiarydetailspanel.nameofbeneficiary"})} value={this.props.beneficiary.fullName} />
          </Col>
          <Col md={6} sm={12}>
            <FieldValueVerticalCell
                title={intl.formatMessage({id: "app.panel.beneficiarydetailspanel.beneficiary.type"})}
                value={this.props.beneficiary.beneficiaryType}/>
          </Col>
          <Col md={6} sm={12}>
            <FieldValueVerticalCell
              title={intl.formatMessage({id: "app.panel.beneficiarydetailspanel.bankcountry"})}
              value={this.props.beneficiary.bankCountryName}/>
          </Col>
        </Row>
        <Row>      
          <Col md={6} sm={12}>
            <FieldValueVerticalCell
              title={intl.formatMessage({id: "app.panel.beneficiarydetailspanel.currency"})}
              value={this.props.beneficiary.transferCurrencies}/>
          </Col>
          <Col md={6} sm={12}>
            <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.beneficiarydetailspanel.bankaccountno"})} value={this.props.beneficiary.accountNumber} />
          </Col>
          <Col md={8} sm={12}>
            <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.beneficiarydetailspanel.bankname"})} value={this.props.beneficiary.bankName} />
          </Col>
        </Row>

        {/*{this.props.beneficiary.virtualAccounts && this.props.beneficiary.virtualAccounts.length > 0 && (
            <>
              <Divider />
            <RadioGroup style={{width:"100%"}} onChange={event => this.onAccountSelected(event.target.value)} value={this.props.selectedBeneficiaryVAId}>

              {this.props.beneficiary.virtualAccounts.map(item => {

                let location = '';
                if (item.virtualAccountChannelCode == 'DBS_HK') {
                  location = "Hong Kong"
                } else if (item.virtualAccountChannelCode == 'DBS_SG') {
                  location = "Singapore"
                } else if (item.virtualAccountChannelCode == 'SAHABAT_SAMPOERNA') {
                  location = "Indonesia"
                } else if (item.virtualAccountChannelCode == 'FLASH_FX') {
                  location = "Australia"
                }

                let balanceStr = '';
                if (item.balanceStr) {
                  let balanceArray = item.balanceStr.split(',');
                  for (var i = 0; i < balanceArray.length; i++) {
                    if (balanceArray[i].includes(this.props.payment.targetValue.currency)) {
                      balanceStr = balanceArray[i];
                      break;
                    }
                  }
                }


                let disabledVa = this.props.disabledBene;
                if(!item.virtualAccountNumber) {
                  disabledVa = true;
                }else {
                  if (!item.currencies || !item.currencies.includes(this.props.targetCurrency)) {
                    disabledVa = true;
                  }
                }

                return (
                    <>
                      <Row style={{marginTop: "20px"}}>
                        <Col md={6} sm={12} style={{paddingTop: "10px", paddingLeft: "60px"}}>

                          <Radio disabled={disabledVa} value={item.id} checked={this.props.selectedBeneficiaryVAId === item.id}>
                          </Radio>

                        </Col>
                        <Col md={8} sm={12}><FieldValueVerticalCell title={'VA Location'} value={location}/></Col>
                        <Col md={5} sm={12}><FieldValueVerticalCell title={'VA Balance'} value={balanceStr}/></Col>

                      </Row>
                      <Row style={{marginTop: "8px"}}>
                        <Col md={6} sm={12}></Col>
                        <Col md={8} sm={12}><FieldValueVerticalCell title={'VA Name'} value={item.virtualAccountName}/></Col>
                        <Col md={5} sm={12}><FieldValueVerticalCell title={'VA No'} value={item.virtualAccountNumber}/></Col>

                      </Row>
                      <Divider />
                    </>
                );
              })}
            </RadioGroup>
            </>
        )}*/}

      </div>
      </>
    )
  }
}

export default withUseIntl(BeneficiaryDetailsPanel);
